import { React, useState } from "react";
import { Row, Col } from "reactstrap";

const SpecialInstructions = ({ selectedItem, setSelectedItem, bgColor, type = "item" }) => {
  const [isFocused, setIsFocused] = useState(false);

  const isItem = type === "item";
  const handleNoteChange = (e) => {
    setSelectedItem((prev) => ({
      ...prev,
      notes: e.target.value,
    }));
  };

  return (
    <Row className={`${isItem ? "mt-4" : "mt-0"} mx-2`}>
      <Col xs={12} className="px-0 normal-heading">
        <label
          htmlFor="notes"
          style={{
            display: "block",
            marginBottom: "6px",
            fontWeight: 600,
            fontSize: "18px",
          }}
        >
          Special instructions
        </label>

        <textarea
          id="notes"
          name="notes"
          rows={3}
          className="form-control"
          placeholder="Any special requests for this item..."
          value={selectedItem.notes}
          onChange={handleNoteChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            border: isFocused ? `2px solid ${bgColor}` : "1px solid rgb(201, 201, 206)",
            borderRadius: "5px",
            color: "#000000",
            backgroundColor: "#ffffff",
            padding: "10px",
            resize: "vertical",
            transition: "border 0.1s ease",
          }}
        />
      </Col>
    </Row>
  );
};

export default SpecialInstructions;
